// extracted by mini-css-extract-plugin
export default {"active":"NarrativesNavigation_active__Y07Tj"};